export default {
    _prefix: "agentScoringRules.editor",
    labels: {
        newRuleTitle: "New Agent Scoring Rule",
        editRuleTitle: "Agent Scoring Rule Editor",
        createRuleDescription:
            "Create a rule by choosing how many interactions to analyze and selecting a form to evaluate the interaction and generate a score.",
        interactionVolumeLabel: "Interaction Volume",
        allInteractionsOption: "All interactions",
        percentageInteractionsOption: "Percentage of interactions",
        setPercentageLabel: "Set Percentage",
        setPercentagePlaceholder: "i.e. 20%",
        evaluationFormLabel: "Agent Auto-Complete Evaluation Form",
        evaluationFormPlaceholder: "Type or select a form",
        addRuleButton: "Add Rule",
        saveRuleButton: "Save Rule",
        cancelButton: "Cancel",
        loading: "Loading",
    },
    errors: {
        samplingPercentage: "Enter a sampling percentage between 0.01 and 100.",
        duplicateRule:
            "This form is already used by another rule in this program. Please select a different form.",
    },
};
